import styled from "styled-components";
import { colors } from "@mui/material";

export const CommentsInputWrapper = styled.div`
	.MuiAlert-icon {
		margin: 0 10px;
	}
	.comment_frame_content_wrapper {
		.inputs_wrapper {
			margin-top: 10px;
			display: flex;
			flex-direction: column;
			grid-gap: 10px;
			.MuiOutlinedInput-root {
				padding: 0;
			}
			.MuiInputBase-inputMultiline {
				padding: 12px;
			}
		}
		.send_btn {
			background: ${({ theme }) => theme.palette.secondary.dark};
			&.Mui-disabled {
				background: ${colors.grey[300]};
			}
			margin-top: 15px;
			padding: 5px 40px;
		}
	}
	.upload_memory_btn {
		margin-top: 10px;
	}
`;
